import { ExpenseItemDetailPage } from '@/features/expense-item/pages/ExpenseItemDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/expense-item/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["expense_item.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ExpenseItemDetailPage,
});
